import { useFrame } from '@react-three/fiber'
import { CuboidCollider, RigidBody } from '@react-three/rapier'
import { useControls } from 'leva'
import { useRef } from 'react'
import * as THREE from 'three'

export default function ShapeSpade()
{
    const spade = useRef()
    const spadeTwo = useRef()
    const spadeTop = useRef()
    const spadeBack = useRef()
    const spadeFront = useRef()
    
    const leva = useControls({
        moveUp:{value:16, min:0 , max:20},
        moveForward:{value:15, min:-2.5 , max:15},
        rotate:{value:0, min:0 , max:0.6},
    })

    useFrame(()=>{
        // rotation
        const eulerRotation = new THREE.Euler(leva.rotate, 0, 0)
        const quaternionRotation = new THREE.Quaternion()
        quaternionRotation.setFromEuler(eulerRotation)
        spade.current.setNextKinematicRotation(quaternionRotation)
        // move
        spade.current.setNextKinematicTranslation({
            x:0,
            y:leva.moveUp,
            z:-leva.moveForward + 1.5
        })

        // rotation
        const eulerRotationTwo = new THREE.Euler(-leva.rotate, 0, 0)
        const quaternionRotationTwo = new THREE.Quaternion()
        quaternionRotationTwo.setFromEuler(eulerRotationTwo)
        spadeTwo.current.setNextKinematicRotation(quaternionRotationTwo)
        // move
        spadeTwo.current.setNextKinematicTranslation({
            x:0,
            y:leva.moveUp,
            z:-leva.moveForward - 1.5
        })

        // rotation
        const eulerRotationTop = new THREE.Euler(Math.PI / 2, 0, 0)
        const quaternionRotationTop = new THREE.Quaternion()
        quaternionRotationTop.setFromEuler(eulerRotationTop)
        spadeTop.current.setNextKinematicRotation(quaternionRotationTop)
        // move
        spadeTop.current.setNextKinematicTranslation({
            x:0,
            y:leva.moveUp + 2.6 ,
            z:-leva.moveForward
        })

        /**
         * Back
         */
        // rotation
        const eulerRotationBack = new THREE.Euler(0, Math.PI / 2, 0)
        const quaternionRotationBack = new THREE.Quaternion()
        quaternionRotationBack.setFromEuler(eulerRotationBack)
        spadeBack.current.setNextKinematicRotation(quaternionRotationBack)
        // move
        spadeBack.current.setNextKinematicTranslation({
            x:-2,
            y:leva.moveUp,
            z:-leva.moveForward
        })
        /**
         * Front
         */
        // rotation
        const eulerRotationFront = new THREE.Euler(0, Math.PI / 2, 0)
        const quaternionRotationFront = new THREE.Quaternion()
        quaternionRotationFront.setFromEuler(eulerRotationFront)
        spadeFront.current.setNextKinematicRotation(quaternionRotationFront)
        // move
        spadeFront.current.setNextKinematicTranslation({
            x:2,
            y:leva.moveUp,
            z:-leva.moveForward
        })
    })

    return <>

        <RigidBody type='kinematicPosition' ref={spade}>
            <mesh>
                <boxGeometry args={[4,5,0.25]} />
                <meshStandardMaterial color={'tomato'} />
            </mesh>
        </RigidBody>

        <RigidBody type='kinematicPosition' ref={spadeTwo}>
            <mesh>
                <boxGeometry args={[4,5,0.25]} />
                <meshStandardMaterial color={'tomato'} />
            </mesh>
        </RigidBody>

        <RigidBody type='kinematicPosition' ref={spadeTop}>
            <mesh>
                <boxGeometry args={[4,5,0.25]} />
                <meshStandardMaterial color={'tomato'} />
            </mesh>
        </RigidBody>

        <RigidBody type='kinematicPosition' ref={spadeBack}>
            <CuboidCollider args={[2, 2.5, 0.125]} />
        </RigidBody>

        <RigidBody type='kinematicPosition' ref={spadeFront}>
            <CuboidCollider args={[2, 2.5, 0.125]} />
        </RigidBody>

    </>
}